import { render, staticRenderFns } from "./RequestW9Modal.vue?vue&type=template&id=acfd6518&"
import script from "./RequestW9Modal.vue?vue&type=script&lang=ts&"
export * from "./RequestW9Modal.vue?vue&type=script&lang=ts&"
import style0 from "./RequestW9Modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports